import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { PerformanceMetricsAction } from './performanceMetrics.action';
import { performanceMetricsInitialState } from './performanceMetrics.constant';

export const performanceMetricsReducer = reducerWithInitialState(performanceMetricsInitialState)
  .case(PerformanceMetricsAction.load.started, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Started,
  }))
  .case(PerformanceMetricsAction.load.done, (state, { result }) => ({
    ...state,
    data: result,
    networkStatus: NetworkStatus.Done,
  }))
  .case(PerformanceMetricsAction.load.failed, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Failed,
  }))
  .case(PerformanceMetricsAction.destroy, () => ({
    ...performanceMetricsInitialState,
  }));
